export const mainColor = "#0C2F50";
export const mainDark = "#012141";
export const bodyBackgroundColor = "#F5F5EF";
